exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dash-banner-index a[data-v-366616d0]{overflow:hidden!important;height:100%!important;width:100%!important;display:block!important;margin:0!important;padding:0!important;border-radius:4px!important}.dash-banner-index a img[data-v-366616d0]{width:100%;height:170px;background-size:cover!important;border-radius:4px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-366616d0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/banners/BottomBanner.vue
// module id = moMS
// module chunks = 0